if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_pnpm_mui_icons-material_5_18_0__mui_material_5_18_0__emotion_react_11_14-c3a96b":1,"src_components_Country_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_sl-f5e46e":1,"src_components_RegionInfo_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules-b297f3":1,"src_components_ActivityInfo_js-node_modules_pnpm_react-i18next_11_18_6_i18next_19_9_2_react-d-9c8e1f":1,"vendors-node_modules_pnpm_hookform_resolvers_2_9_11_react-hook-form_7_48_2_react_18_3_1__node-0d92da":1,"vendors-node_modules_pnpm_video_js_7_21_7_node_modules_video_js_dist_video-js_css":1,"vendors-node_modules_pnpm_adyen_adyen-web_6_41_0_node_modules_adyen_adyen-web_dist_es_adyen_css":1,"src_pages_ItinerariesPageDefault_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_-2e2b18":1,"src_pages_ItinerariesPageJacada_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_m-3e5e3e":1,"src_pages_ItinerariesPageYellowZebra_js-common_components_Modals_BaseModal_js-node_modules_pn-209aa2":1,"src_pages_ItinerariesPageWilderness2_js-common_components_Modals_BaseModal_js-node_modules_pn-3c11f0":1,"src_components_landing_common_WatchVideoButton_js-src_pages_ItinerariesPageWilderness_js-comm-741f6d":1,"src_utils_Itineraries_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_sli-7c05a10":1,"src_pages_ItineraryPageYellowZebra_js-src_utils_Itineraries_js-node_modules_pnpm_slick-carous-16f5f6":1,"src_utils_Itineraries_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_sli-7c05a11":1,"src_utils_Itineraries_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_sli-7c05a12":1,"common_hooks_user_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_slick-c-8a0ac00":1,"src_pages_ItineraryPageYellowZebra_js-common_hooks_user_js-node_modules_pnpm_slick-carousel_1-053c8f":1,"common_hooks_user_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_slick-c-8a0ac01":1,"common_hooks_user_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules_slick-c-8a0ac02":1,"src_pages_QuestionsPageWilderness2_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_nod-2d2baf":1,"src_pages_CampPageWilderness2_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_mod-961bc4":1,"src_pages_CampPageDefault_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modules-5f48c9":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded